import React from 'react'
import { ContactIcon } from '../../../icon/icons'
import { Link } from 'react-router-dom'
import './accounthelp.scss'
const AccountHelp = () => {
    return (
        <div className='accounthelp'>
            <div className='common-heading'>
                <h2>Account help</h2>
            </div>
            <div className='text'>
                <p>If you have additional questions—about your Sentry customer account, the status of a claim, or any other topic—give us a call today. We’ll help you find the answers you need.</p>
            </div>
            <div className="iconLinkWrapper ">
                    <ContactIcon />
                    <p>800-473-6879</p>
            </div>
        </div>
    )
}

export default AccountHelp
